<template>
  <div class="page_sankey">
    <div class="head">
      <h1>{{time}}</h1>
      <p class="tip">
        <span class="item bd">输入广东病例数</span>
        <span class="item center">点击色块或连线查看</span>
        <span class="item bd">具体城市病例数</span>
      </p>
    </div>
    <div id="sankeyMap" v-if="showSankey"></div>
    <div class="error_wrapper" v-if="!showSankey">暂无数据</div>
  </div>
</template>

<script>
import { getSankeyList } from "@/api/countryEvent";
export default {
  data() {
    return {
      showSankey: true,
      time: '',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    exchangeDay(day) {
      let time = new Date(day);
      let month = time.getMonth() + 1;
      let days = time.getDate();
      if (days < 10) days = "0" + days;
      return `${month}月${days}日`;
    },
    getList() {
      getSankeyList()
        .then(res => {
          if (res.code == 200 && res.data.length) {
            this.initChart(res.data[0].nfXlsForeignInputCaseList);
            this.time = this.exchangeDay(res.data[0].id)
          }
        })
        .catch(e => {
          console.log(e);
          this.showSankey = false
        });
    },
    initChart(population) {
      population = population.map(i => {
        return {
          ...i,
          source: i.country,
          target: i.city,
          value: i.count
        };
      });
      let myChart = echarts.init(document.getElementById("sankeyMap"));
      // 颜色设置
      const colorArr = [
        "#6daeeb",
        "#b8b96e",
        "#afb4da",
        "#d4c59e",
        "#f391a8",
        "#f9b278",
        "#d0a8a8",
        "#fdddbe",
        "#faa99a",
        "#a4e2e8",
        "#f0df87",
        "#aed8ba"
      ];
      const fakerCity = population.map(i => i.country);
      const fakerCity2 = population.map(i => i.city);
      const realCity = [...new Set(fakerCity.concat(fakerCity2))];
      // 每个城市的颜色设置
      let citylist = realCity.map((i, j) => {
        return {
          name: i,
          itemStyle: {
            color: colorArr[j % 12],
            borderColor: colorArr[j % 12],
          }
        };
      });
      let city = {};
      citylist.forEach(i => {
        city[i.name] = i.itemStyle.color;
      });
      let data = [];
      for (let i = 0; i < population.length; i++) {
        let color = new echarts.graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: city[population[i].source]
          },
          {
            offset: 1,
            color: city[population[i].target]
          }
        ]);
        data.push({
          source: population[i].source,
          target: population[i].target,
          value: population[i].value,
          lineStyle: {
            color
          }
        });
      }
      // 对数字进行排序
      data = data.sort(function(a, b) {
        return a.value > b.value ? -1 : a.value > b.value ? 1 : 0;
      });
      const sankeyList = this.sortCity(citylist, data);
      const option = {
        title: {
          text: "",
          subtext: "",
          top: "top",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          formatter: (data)=> {
            if (data.data.source && data.data.target) {
              return `${data.data.source}&nbsp;&nbsp;输入&nbsp;&nbsp;${data.data.target}:${data.data.value}`
            } else if (data.data.name && data.data.value) {
              return `${data.data.name}:&nbsp;${data.data.value}`
            }
          }
        },
        series: [
          {
            type: "sankey",
            data: sankeyList,
            links: data,
            draggable: false,
            nodeAlign: "justify",
            layoutIterations: 0,
            top: "26px",
            right: "30px",
            left: "0",
            bottom: "1%",
            nodeWidth: 80,
            nodeGap: 15, // 高度
            focusNodeAdjacency: "allEdges",
            itemStyle: {
              normal: {
                opacity: 1
              }
            },
            lineStyle: {
              normal: {
                curveness: 0.5,
                opacity: .5
              }
            },
            label: {
              show: true,
              position: 'right'
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    // 国家城市桑基图排序: 从多到少
    // todo: 有时间优化这里
    sortCity(list, data) {
      let newArr = [];
      list.forEach(i => {
        let itemFilterVal = data
          .filter(j => i.name == j.source)
          .map(i => i.value);
        let itemFilterVal2 = data
          .filter(j => i.name == j.target)
          .map(i => i.value);
        if (itemFilterVal.length) {
          newArr.push({
            name: i.name,
            value: this.sum(itemFilterVal)
          });
        }
        if (itemFilterVal2.length) {
          newArr.push({
            name: i.name,
            value: this.sum(itemFilterVal2)
          });
        }
      });
      newArr = newArr.sort(function(a, b) {
        return a.value > b.value ? -1 : a.value > b.value ? 1 : 0;
      });
      const returnArr = []
      newArr.forEach(j => {
        let jtem = list.filter(i => i.name == j.name)[0]
        jtem.value = j.value
        returnArr.push(jtem)
      })
      return returnArr
    },
    sum(arr) {
      return arr.reduce((prev, curr) => {
        return prev + curr;
      });
    }
  }
};
</script>

<style lang="less" scoped="scoped">
.page_sankey {
  padding: 0 10px;
  #sankeyMap {
    height: 100vh;
  }
  .error_wrapper {
    height: 200px;
    text-align: center;
    margin-top: 50px;
  }
  .head {
    h1 {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 1px;
      color: #494949;
      text-align: center;
    }
    .tip {
      display: flex;
      .item {
        font-size: 12px;
        text-align: center;
        &.center {
          flex: 1;
          color: #999ea5;
        }
        &.bd {
          border-bottom: 2px solid #c7ccd5;
          width: 90px;
          color: #494949;
        }
      }
    }
  }
}
</style>
